import 'jquery-blockui';

document.addEventListener('alpine:init', () => {
  Alpine.data('puppyPalsLoginQLD', (input) => {
    const ajax = { url: '/wp-admin/admin-ajax.php' };
    let form = null;
    let $form = null;

    return {
      ...input,
      activeIndex: 0,
      errors: {},
      _errorMsg: '',
      _loading: false,

      init() {
        this.initialize();
      },

      initialize() {
        form = document.getElementById('puppy-pals-login');
        $form = $(form);

        $form.on('submit', (e) => {
          e.preventDefault();

          $.ajax({
            url: ajax.url,
            type: 'POST',
            data: {
              action: 'login_user_portal',
              pwd: $('input[name="login-password"]').val(),
              user_role: 'puppy_pal',
              user: $('input[name="login-email"]').val(),
              nonce: $('#portal_user_login').val(),
              remember_me: 1,
            },
            success(data) {
              if (data.success === 1) {
                window.dataLayer.push({
                  event: 'GApuppyPalsPortalLoginSubmit',
                });
                window.location.href = '/portal-category/home/';
              } else {
                // TODO: Display error message in alert panel
                alert(data.msg);
              }
            },
          });
        });
      },

      loading(isLoading = true) {
        // TODO add a spinner in the html that read this as well
        this._loading = isLoading;
      },
      error(errorMessage) {
        this._errorMsg = errorMessage;
      },
    };
  });
});
